import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/403')({
  component: Error403Page,
});

function Error403Page() {
  return (
    <div className="min-h-screen grid place-items-center p-10">
      <div className="w-full max-w-xl text-center rounded-2xl bg-white p-10 shadow-md">
        <div className="text-6xl font-extrabold tracking-tight text-gray-900">403</div>
        <h1 className="mt-4 text-3xl font-semibold text-gray-900">Access Denied</h1>
        <p className="mt-6 text-gray-600">You do not have permission to view the requested page.</p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to="/"
            className="rounded-md border px-6 py-3 text-base font-medium text-white bg-air-primary hover:bg-air-primary-hover active:bg-air-primary-active"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
